import {AfterViewChecked, ChangeDetectorRef, Component, OnInit,
  ViewChild
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilService} from 'src/app/modules/common/services/util.service';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {AddressesArrayDTO} from '../../../models/AddressesArrayDTO';
import {ContactArrayDTO} from '../../../models/ContactsArrayDTO';
import {PolicyholderGroupService} from '../../../services/policyholder-group.service';
import {LookupService} from '../../../../common/services/lookup.service';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';
import {NameValueDTO} from '../../../../common/models/NameValueDTO';
import {ContactFormComponent} from '../../../../common/components/common-steps/contact-form/contact-form.component';
import {AddressFormComponent} from '../../../../common/components/common-steps/address-form/address-form.component';
import {debounceTime, take, takeUntil} from 'rxjs/operators';
import {PolicyholderGroupDTO} from '../../../models/PolicyholderGroupDTO';
import {SharedService} from '../../../../common/services/shared-service';
import {Subject} from 'rxjs';
import {KeycloakService} from 'keycloak-angular';
import {UserAuthorisationService} from '../../../../common/services/user-authorisation.service';
import {DisplayStrings} from '../../../../common/constants/DisplayStrings';
import {EntityStatusesLinkDTO} from '../../../models/EntityStatusesLinkDTO';
import {EnterpriseRoutesQueryParam} from '../../../../common/types/routes-query-param.enum';
import {GroupCountRangeDTO} from '../../../models/GroupCountRangeDTO';
import {
  UnderwritingConcession,
  UnderwritingConcessionDialogComponent,
  UnderwritingConcessionDialogData
} from '../../../../common/dialogs/underwriting-concession-dialog/underwriting-concession-dialog.component';
import {PolicyholderGroupUnderwritingTypeLinkDTO} from '../../../models/PolicyholderGroupUnderwritingTypeLinkDTO';
import {PortalType} from '../../../../common/types/portal.enum';
import {
  ConfirmationDialogComponent
} from '../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import { PagedRequestDTO } from 'src/app/modules/common/models/PagedRequestDTO';
import { Common } from 'src/app/modules/common/util/Util';
import { CreateNameValueCodeDTO, NameValueCodeDTO } from 'src/app/modules/common/models/NameValueCodeDTO';

@Component({
  selector: 'app-add-policyholder-view',
  templateUrl: './add-policyholder-view.component.html',
  styleUrls: ['./add-policyholder-view.component.scss', '../../../../../../styles/global/_add-view-edit-styles.scss']
})
export class AddPolicyholderViewComponent implements OnInit, AfterViewChecked {
  readonly destroyed$ = new Subject();
  readonly lookupValue = LookupValue;
  readonly BUSINESS_TYPE_ATOMIC_GROUP_ID = 17;
  readonly BUSINESS_TYPE_CENTRAL_GROUP_ID = 18;
  readonly debounceTime = Common.HALF_SECOND_DEBOUNCE;

  heading: string;
  backPageName: string;
  isEditMode: boolean;
  isBusinessTypeDisabled: boolean = false;
  // General Step FormControls
  nameFormControl: FormControl;
  startDateFormControl: FormControl;
  endDateFormControl: FormControl;
  processingClassFormControl: FormControl;
  policyNameFormControl: FormControl;
  businessTypeFormControl: FormControl;
  brokerFormControl: FormControl;
  centralGroupFormControl: FormControl;
  underwritingCategoryFormControl: FormControl;
  groupCountRangeFormControl: FormControl; // Add this line
  businessLicenseScannedCopy = null;
  generalFormGroup: FormGroup;
  policyholderGroupId = null;
  tabName: string;
  helpInfo: HelpDTO[];

  // Lookup values
  businessTypes: NameValueDTO[] = [];
  brokers: NameValueDTO[] = [];
  underwritingCategories: NameValueDTO[] = [];
  groupCountRanges: NameValueDTO[] = []; // Add this line
  entityStatus: NameValueDTO[] = [];

  businessLicenseExpiryFormControl: FormControl;
  businessLicenseNumberFormControl: FormControl;
  policyholderGroupFormControl: FormControl;
  entityStatusFormControl: FormControl;
  policyholderGroupNumber: FormControl;
  vatApplicable = 'No';
  loggedInUserName = '';

  // Statutory Step FormControls
  statutoryFormGroup: FormGroup;
  vatNumberFormControl: FormControl;
  licenseCopyFormControl: FormControl;
  gstApplicable = 'No';
  sanctionCheckReferenceNumber: FormControl;
  sanctionCheckDate: FormControl;
  sanctionResult: FormControl;
  gstNumber: FormControl;

  selectedAddresses: AddressesArrayDTO[];
  selectedContacts: ContactArrayDTO[];
  selectedCoverStatuses = [];
  selectedPolicyHolderGroup: PolicyholderGroupDTO;
  underwritingConcessionsType: NameValueDTO[] = [];
  centralGroupTextChanged: Subject<string> = new Subject<string>();
  filteredCentralGroups: PolicyholderGroupDTO[] = [];
  selectedCentralGroup: NameValueCodeDTO;
  private filteredCentralGroups$ = new Subject<PolicyholderGroupDTO[]>();


  customRoute: string;
  allowedToEditConcessions = false;
  isControlGroupDisabled: boolean;

  protected underwritingConcessions: PolicyholderGroupUnderwritingTypeLinkDTO[] = [];
  private addressPayload: { addresses: AddressesArrayDTO[] };
  private contactPayload: { contacts: ContactArrayDTO[] };

  @ViewChild('addressFormComponent', {static: false}) private addressFormComponent: AddressFormComponent;
  @ViewChild('contactFormComponent', {static: false}) private contactFormComponent: ContactFormComponent;

  currentPortal: PortalType;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private helpService: HelpService,
    private lookupService: LookupService,
    private router: Router,
    private sharedService: SharedService,
    private utilService: UtilService,
    private keycloakService: KeycloakService,
    private policyGroupHolderService: PolicyholderGroupService,
    private userAuthorisationService: UserAuthorisationService
  ) {
    const parentData = this.route.parent?.snapshot.data;
    this.currentPortal = parentData?.portalType || PortalType.Normal;
    this.customRoute = this.getCustomRoute();

    this.route.params.subscribe(params => {
      this.policyholderGroupId = params.id;
    });
    this.selectedAddresses = [];
    this.selectedContacts = [];
    this.tabName = EnterpriseRoutesQueryParam.PolicyHolderGroups;
    this.backPageName = 'enterprise-management';
    this.nameFormControl = new FormControl();
    this.brokerFormControl = new FormControl();
    this.centralGroupFormControl = new FormControl();
    this.underwritingCategoryFormControl = new FormControl();
    this.processingClassFormControl = new FormControl();
    this.policyholderGroupFormControl = new FormControl();
    this.groupCountRangeFormControl = new FormControl();
    this.sanctionResult = new FormControl();
    this.sanctionCheckDate = new FormControl();
    this.initializeFormControls();
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then(profile => {
      this.loggedInUserName = `${profile.firstName} ${profile.lastName}`;
    });

    const currentPath = this.route.snapshot.url.map(segment => segment.path).join('/');

    if (currentPath.includes('edit-policyholder-group')) {
      this.getHelpInfo('Policyholder Group');
      this.heading = 'Edit Policyholder Group';
      this.tabName = EnterpriseRoutesQueryParam.PolicyHolderGroups;
      this.getPolicyGroupHolderById(this.policyholderGroupId);
      this.isEditMode = true;
    } else if (currentPath.includes('add-policyholder-group')) {
      this.getHelpInfo('Policyholder Group');
      this.heading = 'Add Policyholder Group';
      this.tabName = EnterpriseRoutesQueryParam.PolicyHolderGroups;
      this.isEditMode = false;
    }

    this.getListOfLookupValues(this.lookupValue.BusinessTypeByGroup);
    this.getListOfLookupValues(this.lookupValue.EntityStatus);
    this.getListOfLookupValues(this.lookupValue.Broker);
    this.getListOfLookupValues(this.lookupValue.UnderwritingCategory);
    this.getListOfLookupValues(this.lookupValue.GroupCountRange);
    this.getListOfLookupValues(this.lookupValue.UnderwritingType);
    this.allowedToEditConcessions = this.isAllowedToEditConcessions();
    this.centralGroupTextChanged
          .pipe(
            debounceTime(this.debounceTime),
            takeUntil(this.destroyed$)
          )
          .subscribe(value => {
            if (value) {
              this.searchCentralGroups(value);
            }
          });
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  onCentralGroupBlur(): void {
    const currentValue = this.centralGroupFormControl?.value;
    const hasMatch = this.filteredCentralGroups.some(group =>
      this.getCentralGroupDisplayStringFromPolicyholderGroupDTO(group)?.toLowerCase() === currentValue?.toLowerCase()
    );

    if (!currentValue || !this.filteredCentralGroups.length || !hasMatch) {
      this.centralGroupFormControl?.patchValue(null);
    }
  }

  searchCentralGroups(searchValue: string): void {
      const pagedRequestDTO: PagedRequestDTO = {
        entityClass: 'TblPolicyholderGroup',
        pageSize: 10,
        pageNumber: 0,
        sortField: 'name',
        sortDirection: 'ASC',
        fieldMap: {}
      };

      const fields = [
        {key: 'name', name: 'name', logicGate: 'AND', bracket: '(', value: searchValue},
        {key: 'policyholderGroupNumber', name: 'policyholderGroupNumber', logicGate: 'OR', bracket: ')', value: searchValue},
        {key: 'businessTypeByBusinessTypeId', name: 'businessTypeByBusinessTypeId.businessTypeId', logicGate: 'AND', bracket: '', value: 18}
      ];

      fields.forEach((field) => {
        pagedRequestDTO.fieldMap[field.key] = {
          name: field.name,
          value: field.value,
          logicGate: field.logicGate,
          bracket: field.bracket || ''
        };
      });

      this.policyGroupHolderService.getListOfPolicyholderGroups(pagedRequestDTO)
        .pipe(
          take(1),
          debounceTime(this.debounceTime),
        )
        .subscribe({
          next: (response) => {
            this.filteredCentralGroups = response.resultList;
            this.filteredCentralGroups$.next(response.resultList);
          },
          error: (error) => console.error('Error fetching central groups:', error)
        });
    }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService
      .getListOfLookupValues(entity)
      .pipe(takeUntil(this.destroyed$)).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.BusinessTypeByGroup) {
          this.businessTypes = response;
        }
        else if (entity === this.lookupValue.EntityStatus) {
          this.entityStatus = response.filter(x => x.value != 0);
        } else if (entity === this.lookupValue.Broker) {
          this.brokers = response;
        } else if (entity === this.lookupValue.UnderwritingCategory) {
          this.underwritingCategories = response;
        } else if (entity === this.lookupValue.GroupCountRange) {
          this.groupCountRanges = response;
        } else if (entity === this.lookupValue.UnderwritingType) {
          this.underwritingConcessionsType = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getPolicyGroupHolderById(policyholderGroupId: number): void {
    this.policyGroupHolderService.getPolicyholderGroup(policyholderGroupId).subscribe(
      (response: PolicyholderGroupDTO) => {
        this.selectedPolicyHolderGroup = response;
        this.setFormsForEdit(response);
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  onBusinessTypeSelectionChange(value): void {
    if (value == this.BUSINESS_TYPE_ATOMIC_GROUP_ID){
      this.centralGroupFormControl.setValidators([Validators.required]);
      this.centralGroupFormControl.enable();
      this.isControlGroupDisabled = false;
    }else{
      this.centralGroupFormControl.setValidators([]);
      this.selectedCentralGroup = null;
      this.centralGroupFormControl.setValue('');
      this.centralGroupFormControl.disable();
      this.isControlGroupDisabled = true;
    }
    this.centralGroupFormControl.updateValueAndValidity();
  }

  onCentralGroupSelectionChange(value): void {
    const filteredCentralGroup  = this.filteredCentralGroups.find(item => item.policyholderGroupId === value);
    this.selectedCentralGroup = CreateNameValueCodeDTO(filteredCentralGroup.policyholderGroupId, filteredCentralGroup.name , filteredCentralGroup.policyholderGroupNumber);
    this.centralGroupFormControl.setValue(this.getCentralGroupDisplayStringFromPolicyholderGroupDTO(filteredCentralGroup));
  }

  setFormsForEdit(data) {
    this.policyNameFormControl.setValue(data.name);
    this.businessTypeFormControl.setValue(data?.businessType?.value);
    if(data?.businessType?.value === this.BUSINESS_TYPE_CENTRAL_GROUP_ID){
      this.isBusinessTypeDisabled = true;
    }
    this.sanctionResult.setValue(data.sanctionIndicator === 1 ? 'Passed' : 'Failed');
    this.selectedCoverStatuses = data.entityStatuses;
    this.underwritingConcessions = this.sortUnderwritingConcessions(data.underwritingConcessions);
    this.onBusinessTypeSelectionChange(data?.businessType?.value);

    if (this.selectedCoverStatuses && this.selectedCoverStatuses.length) {
      const sortArray = this.selectedCoverStatuses.sort((a, b) => b.startDate - a.startDate);
      if (this.selectedCoverStatuses.length > 1) {
        for (let i = 0; i < this.selectedCoverStatuses.length - 1; i++) {
          this.selectedCoverStatuses[i + 1].endDate =
            new Date(new Date(this.selectedCoverStatuses[i].startDate)
              .setDate(new Date(this.selectedCoverStatuses[i].startDate).getDate() - 1));
        }
      }

      this.entityStatusFormControl.setValue(sortArray[0].entityStatusDTO.name);
      this.startDateFormControl.setValue(sortArray[0].startDate ? new Date(sortArray[0].startDate) : null);
      this.endDateFormControl.setValue(sortArray[0].endDate ? new Date(sortArray[0].endDate) : null);
    }

    this.policyholderGroupNumber.setValue(data.policyholderGroupNumber);
    this.groupCountRangeFormControl.setValue(data.groupCountRange?.groupCountRangeId);
    this.centralGroupFormControl.setValue(this.getCentralGroupDisplayStringFromNameValueCodeDTO(data?.dapolicyholderGroupParent));

    this.generalFormGroup = this.formBuilder.group({
      name: this.policyNameFormControl,
      businessType: this.businessTypeFormControl,
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl,
      entityStatus: this.entityStatusFormControl,
      policyholderGroupNumber: this.policyholderGroupNumber,
      policyholderGroup: this.policyholderGroupFormControl,
      groupCountRange: this.groupCountRangeFormControl,
      centralGroup: this.centralGroupFormControl
    });
    this.blurPolicyholderOrPolicyholderGroupHeading();
    if (data.addresses && data.addresses.length) {
      this.selectedAddresses = data.addresses;
    }
    if (data.contacts?.length) {
      this.selectedContacts = data.contacts;
    }
    if (data?.policyholderGroupParent){
      this.selectedCentralGroup = data?.policyholderGroupParent;
      this.centralGroupFormControl.setValue(this.getCentralGroupDisplayStringFromNameValueCodeDTO(data?.policyholderGroupParent));
    }
    this.businessLicenseNumberFormControl.setValue(data.businessLicenseNumber);
    this.vatNumberFormControl.setValue(data.vatNumber);
    this.sanctionCheckReferenceNumber.setValue(data.sanctionReference);
    this.gstNumber.setValue(data.gstNumber);
    this.sanctionCheckDate.setValue(data.sanctionCheckDate ? new Date(data.sanctionCheckDate) : null);
    this.businessLicenseExpiryFormControl.setValue(new Date(data.businessLicenseExpiryDate));
    this.gstApplicable = data.gstOverride === 1 ? 'Yes' : 'No';
    this.vatApplicable = data.vatOverride === 1 ? 'Yes' : 'No';
    this.statutoryFormGroup = this.formBuilder.group({
        businessLicenseExpiryDate: this.businessLicenseExpiryFormControl,
        businessLicenseNumber: this.businessLicenseNumberFormControl,
        vatNumber: this.vatNumberFormControl,
        licenseCopy: this.licenseCopyFormControl,
        sanctionCheckReferenceNumber: this.sanctionCheckReferenceNumber,
        gstNumber: this.gstNumber
      }
    );

    // Fix to await 500ms for Lookup value to fetch before setting value
    setTimeout(() => {
      this.setBrokerAndUnderwritingCategory();
      this.isControlGroup();
    }, 500);
  }

  underwritingConcessionsExist(underwritingConcessions: PolicyholderGroupUnderwritingTypeLinkDTO[]) {
    return underwritingConcessions && underwritingConcessions.length > 0;
  }

  initializeFormControls(): void {
    this.initializeGeneralFormControls();
    this.initializeStatuaryFormControls();
  }

  initializeGeneralFormControls(): void {

    this.policyNameFormControl = new FormControl('', [Validators.required]);
    this.businessTypeFormControl = new FormControl('', [Validators.required]);
    this.startDateFormControl = new FormControl('', [Validators.required]);
    this.endDateFormControl = new FormControl('');
    this.entityStatusFormControl = new FormControl('', [Validators.required]);
    this.policyholderGroupNumber = new FormControl('', [Validators.required]);
    this.brokerFormControl = new FormControl('', [Validators.required]);
    this.underwritingCategoryFormControl = new FormControl('', [Validators.required]);
    this.groupCountRangeFormControl = new FormControl('', [Validators.required]); // Add this line

    this.generalFormGroup = this.formBuilder.group({
      name: this.policyNameFormControl,
      businessType: this.businessTypeFormControl,
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl,
      entityStatus: this.entityStatusFormControl,
      policyholderGroupNumber: this.policyholderGroupNumber,
      broker: this.brokerFormControl,
      centralGroup: this.centralGroupFormControl,
      underwritingType: this.underwritingCategoryFormControl,
      groupCountRange: this.groupCountRangeFormControl
    });
  }

  initializeStatuaryFormControls(): void {
    this.businessLicenseExpiryFormControl = new FormControl('', [Validators.required]);
    this.businessLicenseNumberFormControl = new FormControl('', [Validators.required]);
    this.vatNumberFormControl = new FormControl();
    this.licenseCopyFormControl = new FormControl();
    this.sanctionCheckReferenceNumber = new FormControl();
    this.gstNumber = new FormControl();

    this.statutoryFormGroup = this.formBuilder.group({
        businessLicenseExpiryDate: this.businessLicenseExpiryFormControl,
        businessLicenseNumber: this.businessLicenseNumberFormControl,
        vatNumber: this.vatNumberFormControl,
        licenseCopy: this.licenseCopyFormControl,
        sanctionCheckReferenceNumber: this.sanctionCheckReferenceNumber,
        gstNumber: this.gstNumber
      }
    );
  }

  setBrokerAndUnderwritingCategory() {
    const broker = this.brokers.find(item => item.value === this.selectedPolicyHolderGroup?.broker?.value) ?? null;
    const underwritingType = this.underwritingCategories.find(item => item.value === this.selectedPolicyHolderGroup?.underwritingCategory?.value) ?? null;
    this.brokerFormControl.setValue(broker?.value);
    this.underwritingCategoryFormControl.setValue(underwritingType?.value);
  }

  blurPolicyholderOrPolicyholderGroupHeading() {
    if (this.route.snapshot.url[1].path === 'edit-policyholder-group') {
      this.heading = `Edit Policyholder Group - ${this.policyNameFormControl.value}`;
    } else if (this.route.snapshot.url[1].path === 'add-policyholder-group') {
      this.heading = `Add Policyholder Group - ${this.policyNameFormControl.value}`;
    }
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo ? helpInfo.inputInfo : '';
    }
    return message;
  }

  getDateDisplayString(date: Date): string {
    return date ? this.utilService.dateFormat(date) : '';
  }

  getCentralGroupDisplayStringFromNameValueCodeDTO(group: NameValueCodeDTO): string {
    if (group == null) return null;
    return `${group.code}: ${group.name}`;
  }

  getCentralGroupDisplayStringFromPolicyholderGroupDTO(group: PolicyholderGroupDTO): string {
    if (group == null) return null;
    return `${group.policyholderGroupNumber}: ${group.name}`;
  }

  handleInputChangeForLicenseCopy(e) {
    const fileList: FileList = e.target.files;
    const file: File = fileList[0];
    if (file.size > 5000000) {
      return;
    }
    this.getBase64ForLicenseCopy(e);
    this.licenseCopyFormControl.setValue(file.name);
  }

  getBase64ForLicenseCopy(event) {
    const me = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    reader.onload = () => {
      me.businessLicenseScannedCopy = reader.result;
    };
  }

  onInputChangedSearchCentralGroups($event: Event): void {
    const searchText = ($event.target as HTMLInputElement).value;
    this.centralGroupTextChanged.next(searchText);
  }

  resetStatutoryFormGroup() {
    this.statutoryFormGroup.reset();
  }

  isAllowedToSubmit(): boolean {
    let hasAccessToSubmitPolicyholderGroup = false;
    const hasRoleEnterpriseManager = this.userAuthorisationService.hasRoleEnterpriseManager();
    const hasRoleOnboardingManager = this.userAuthorisationService.hasOnBoardingManager();

    if (hasRoleEnterpriseManager) {
      hasAccessToSubmitPolicyholderGroup = true;
    } else if (hasRoleOnboardingManager) {
      hasAccessToSubmitPolicyholderGroup = true;
    }
    return hasAccessToSubmitPolicyholderGroup;
  }

  isFinishButtonDisabled(): boolean {
    return !this.isAllowedToSubmit() ||
      !this.generalFormGroup.valid ||
      !this.statutoryFormGroup.valid ||
      this.addressFormComponent.selectedAddresses.length === 0 ||
      this.contactFormComponent.selectedContacts.length === 0;
  }

  getFinishButtonTooltip(): string | null {
    if (!this.isAllowedToSubmit()) {
      return DisplayStrings.permissionsErrorMessages.rolePermissions.roleEnterpriseManager;
    }

    return DisplayStrings.generic.requiredFields;
  }

  submitPolicyHolderGroup() {
    if (!this.isAllowedToSubmit()) {
      return;
    }

    const payload: PolicyholderGroupDTO = this.getPolicyholderGroupDTOPayload();
    this.policyGroupHolderService.savePolicyholderGroup(payload)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response: PolicyholderGroupDTO) => {
          this.sharedService.openSnackBar(`Policyholder Group ${response.name} saved successfully`, 'Dismiss');
          const route = this.getBackPageRoute();
          this.router.navigate([route.path], {queryParams: route.queryParams});
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  onClickAddUnderwritingConcessions() {
    const dialogData: UnderwritingConcessionDialogData = {
      underwritingTypes: this.underwritingConcessionsType,
      underwritingConcessionsToEdit: [],
      underwritingConcessionsLatestPerType: this.getLatestConcessionPerType(this.underwritingConcessions)
    };

    this.dialog.open(UnderwritingConcessionDialogComponent, {
      data: dialogData,
      width: '45vw',
    }).afterClosed().subscribe(result => {
      if (result) {
        // get additions
        const additions = result.map((concession: UnderwritingConcession) => ({
          underwritingType: concession.underwritingType,
          startDate: concession.startDate ? new Date(concession.startDate) : null,
          endDate: concession.endDate ? new Date(concession.endDate) : null,
          created: new Date(),
          createdBy: this.loggedInUserName,
          updated: this.isEditMode ? new Date() : null,
          updatedBy: this.isEditMode ? this.loggedInUserName : null,
          tenantId: null
        }));

        // add to existing concessions
        this.underwritingConcessions = [
          ...(this.underwritingConcessions || []),
          ...additions
        ];

        // sort the underwriting concessions
        this.underwritingConcessions = this.sortUnderwritingConcessions(this.underwritingConcessions);
      }
    });
  }

  onClickEditUnderwritingConcessions() {
    const remainingConcessions = this.getAllButLatestConcessionsPerType(this.underwritingConcessions);
    const dialogData: UnderwritingConcessionDialogData = {
      underwritingTypes: this.underwritingConcessionsType,
      underwritingConcessionsToEdit: this.getLatestConcessionPerType(this.underwritingConcessions),
      underwritingConcessionsLatestPerType: this.getLatestConcessionPerType(remainingConcessions)
    };

    this.dialog.open(UnderwritingConcessionDialogComponent, {
      data: dialogData,
      width: '45vw',
    }).afterClosed().subscribe(result => {
      if (result) {
        // get edits
        const edits = result.map((concession: UnderwritingConcession) => ({
          underwritingType: concession.underwritingType,
          startDate: concession.startDate ? new Date(concession.startDate) : null,
          endDate: concession.endDate ? new Date(concession.endDate) : null,
          created: new Date(),
          createdBy: this.loggedInUserName,
          updated: this.isEditMode ? new Date() : null,
          updatedBy: this.isEditMode ? this.loggedInUserName : null,
          tenantId: null
        }));

        // add to existing concessions
        this.underwritingConcessions = [
          ...remainingConcessions,
          ...edits
        ];

        // sort the underwriting concessions
        this.underwritingConcessions = this.sortUnderwritingConcessions(this.underwritingConcessions);
      }
    });
  }

  onClickDeleteUnderwritingConcession(concession: PolicyholderGroupUnderwritingTypeLinkDTO) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: `Are you sure you want to delete ${concession.underwritingType.name}?`
    });

    dialogRef.afterClosed()
      .pipe(
        take(1)
      )
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          const index = this.underwritingConcessions
            .findIndex((item: PolicyholderGroupUnderwritingTypeLinkDTO) => {
              return item.underwritingType.value === concession.underwritingType.value && item.startDate === concession.startDate;
            });
          this.underwritingConcessions.splice(index, 1);
        } else {
          dialogRef.close();
        }
      });
  }

  getLatestConcessionPerType(underwritingConcessions: PolicyholderGroupUnderwritingTypeLinkDTO[]): PolicyholderGroupUnderwritingTypeLinkDTO[] {
    return this.underwritingConcessionsType
      .map(type => {
        // filter all concessions of this type
        const concessionsOfType = underwritingConcessions.filter(c =>
          c.underwritingType?.value === type.value
        );

        if (concessionsOfType.length === 0) {
          return null; // no concession for this type
        }

        // pick the one with the latest startDate
        return concessionsOfType.reduce((latest, current) =>
          new Date(current.startDate) > new Date(latest.startDate) ? current : latest
        );
      })
      .filter((c): c is PolicyholderGroupUnderwritingTypeLinkDTO => c !== null);
  }

  getAllButLatestConcessionsPerType(underwritingConcessions: PolicyholderGroupUnderwritingTypeLinkDTO[]): PolicyholderGroupUnderwritingTypeLinkDTO[] {
    const latestConcessions = this.getLatestConcessionPerType(underwritingConcessions);
    return underwritingConcessions.filter(current =>
      !latestConcessions.some(latest => latest.underwritingType.value === current.underwritingType.value && latest.startDate === current.startDate)
    );
  }

  private getPolicyholderGroupDTOPayload(): PolicyholderGroupDTO {
    // ----------------------------
    // Important:
    // Get Updated Payload from each step BEFORE creating Final Payload
    this.setPayloadFromEachStep();
    // ----------------------------

    const entityStatus = this.entityStatus.find(item => item.name === this.entityStatusFormControl.value);
    const businessType = this.businessTypes.find(item => item.value === this.businessTypeFormControl.value);
    const broker = this.brokers.find(item => item.value === this.brokerFormControl.value) ?? null;
    const underwritingCategory = this.underwritingCategories.find(item => item.value === this.underwritingCategoryFormControl.value) ?? null;
    const groupCountRange = this.groupCountRanges.find(item => item.value === this.groupCountRangeFormControl.value) ?? null; // Add this line
    const groupCountRangeDTO = this.getGroupRangeDTOPayload(groupCountRange);

    const payload: PolicyholderGroupDTO = {
      policyholderGroupId: this.policyholderGroupId ? Number(this.policyholderGroupId) : null,
      name: this.policyNameFormControl.value,
      policyholderGroupNumber: this.policyholderGroupNumber.value,
      businessLicenseNumber: this.businessLicenseNumberFormControl.value,
      businessLicenseExpiryDate: new Date(this.businessLicenseExpiryFormControl.value),
      businessLicenseScannedCopy: this.getProcessedBusinessLicenseScannedCopy(),
      vatNumber: this.vatNumberFormControl.value,
      vatOverride: this.vatApplicable === 'Yes' ? 1 : 0,
      gstNumber: this.gstNumber.value,
      gstOverride: this.gstApplicable === 'Yes' ? 1 : 0,
      sanctionCheckDate: this.sanctionCheckDate.value ? new Date(this.sanctionCheckDate.value) : null,
      sanctionReference: this.sanctionCheckReferenceNumber.value,
      sanctionIndicator: this.sanctionResult.value === 'Passed' ? 1 : 0,
      businessType,
      bankAccount: this.selectedPolicyHolderGroup ? this.selectedPolicyHolderGroup.bankAccount : null,
      broker,
      policyholderGroupParent: this.selectedCentralGroup,
      underwritingCategory,
      entityStatuses: this.getEntityStatusLinkDTOPayload(entityStatus),
      groupCountRange: groupCountRangeDTO,
      addresses: this.addressPayload.addresses,
      contacts: this.contactPayload.contacts,
      underwritingConcessions: this.underwritingConcessions,
      created: this.isEditMode ? this.selectedPolicyHolderGroup.created : new Date(),
      createdBy: this.isEditMode ? this.selectedPolicyHolderGroup.createdBy : this.loggedInUserName,
      updated: this.isEditMode ? new Date() : null,
      updatedBy: this.isEditMode ? this.loggedInUserName : null,
      tenantId: null
    } as PolicyholderGroupDTO;

    return payload;
  }

  isControlGroup():void{
    this.isControlGroupDisabled = this.selectedPolicyHolderGroup?.businessType?.value === this.BUSINESS_TYPE_CENTRAL_GROUP_ID;
  }

  private getGroupRangeDTOPayload(groupCountRange: NameValueDTO) {
    const groupCountRangeValue: GroupCountRangeDTO = {
      groupCountRangeId: groupCountRange.value,
      description: groupCountRange.name,
      value: null, // backend JPA will handle mapping based on group count range ID mapping
      created: null,
      createdBy: null,
      updated: null,
      updatedBy: null,
      tenantId: null
    };
    return groupCountRangeValue;
  }

  private setPayloadFromEachStep(): void {
    this.addressPayload = this.addressFormComponent.getPayloadAsDTO();
    this.contactPayload = this.contactFormComponent.getPayloadAsDTO();
  }

  private getProcessedBusinessLicenseScannedCopy(): string | null {
    if (!this.businessLicenseScannedCopy) {
      return null;
    }
    const arr = this.businessLicenseScannedCopy.split('base64,');
    return arr.length > 1 ? arr[1] : this.businessLicenseScannedCopy;
  }

  private getEntityStatusLinkDTOPayload(entityStatus: NameValueDTO): EntityStatusesLinkDTO[] {
    // Todo: Might Need to fix Backend Structure similar to Provider or ProviderGroup DTO
    const entityStatuesLinkDTO: EntityStatusesLinkDTO = this.isEditMode ? this.selectedPolicyHolderGroup.entityStatuses[0] : null;

    const entityStatuses: EntityStatusesLinkDTO[] = [
      {
        entityStatusDTO: {
          entityStatusId: this.isEditMode ? entityStatuesLinkDTO?.entityStatusDTO?.entityStatusId : entityStatus?.value,
          name: entityStatus.name,
          created: this.isEditMode ? entityStatuesLinkDTO?.entityStatusDTO?.created : new Date(),
          createdBy: this.isEditMode ? entityStatuesLinkDTO?.entityStatusDTO.createdBy : this.loggedInUserName,
          updated: this.isEditMode ? new Date() : null,
          updatedBy: this.isEditMode ? this.loggedInUserName : null,
          tenantId: null,
        },
        startDate: this.startDateFormControl.value,
        endDate: this.endDateFormControl.value ?? null,
        created: this.isEditMode ? entityStatuesLinkDTO?.created : new Date(),
        createdBy: this.isEditMode ? entityStatuesLinkDTO?.createdBy : this.loggedInUserName,
        updated: this.isEditMode ? new Date() : null,
        updatedBy: this.isEditMode ? this.loggedInUserName : null,
        tenantId: null,
      }
    ];
    return entityStatuses;
  }

  getEditConcessionsTooltip(): string {
    if (!this.allowedToEditConcessions) {
      return DisplayStrings.permissionsErrorMessages.rolePermissions.generic;
    }

    if (!this.underwritingConcessions.length) {
      return DisplayStrings.generic.dataNotExists;
    }

    return this.getLatestConcessionPerType(this.underwritingConcessions).map(c => {
      const startDate = c.startDate ? this.utilService.dateFormat(c.startDate) : '-';
      const endDate = c.endDate ? this.utilService.dateFormat(c.endDate) : '-';
      return `${c.underwritingType.name}:\n${startDate} to ${endDate}`;
    }).join('; ');
  }

  getAddConcessionsTooltip(): string {
    if (!this.allowedToEditConcessions) {
      return DisplayStrings.permissionsErrorMessages.rolePermissions.generic;
    }
  }

  private getCustomRoute(): string {
    const routes = {
      [PortalType.Normal]: null,
      [PortalType.OnBoarding]: '/onboarding/policyholder-groups',
      [PortalType.Broker]: '/broker/policyholder-groups',
    };
    return routes[this.currentPortal] || null;
  }

  private getBackPageRoute(): { path: string, queryParams: any } {
    const routes = {
      [PortalType.Normal]: {
        path: '/enterprise-management',
        queryParams: {tab: EnterpriseRoutesQueryParam.PolicyHolderGroups}
      },
      [PortalType.OnBoarding]: {path: '/onboarding/policyholder-groups', queryParams: {}},
      [PortalType.Broker]: {path: '/broker/policyholder-groups', queryParams: {}}
    };
    return routes[this.currentPortal] || routes[PortalType.Normal];
  }

  private sortUnderwritingConcessions(underwritingConcessions: PolicyholderGroupUnderwritingTypeLinkDTO[]) {
    if (!this.underwritingConcessionsExist(underwritingConcessions)) {
      return [];
    }
    return underwritingConcessions.sort((a, b) => {
      const aDate = a.startDate ? new Date(a.startDate).getTime() : -Infinity;
      const bDate = b.startDate ? new Date(b.startDate).getTime() : -Infinity;

      // Primary: startDate descending
      if (bDate !== aDate) {
        return bDate - aDate;
      }

      // Secondary: underwritingType (or name) ascending, case-insensitive
      return (a.underwritingType.name ?? '').localeCompare(b.underwritingType.name ?? '', undefined, {
        sensitivity: 'base'
      });
    });
  }

  isAllowedToEditConcessions(): boolean {
    let hasAccessToSubmitPolicyholderGroup = false;
    const hasRoleEnterpriseManager = this.userAuthorisationService.hasRoleEnterpriseManager();
    const hasRoleOnboardingTeamLeader = this.userAuthorisationService.hasOnBoardingTeamLeader();

    if (hasRoleEnterpriseManager) {
      hasAccessToSubmitPolicyholderGroup = true;
    } else if (hasRoleOnboardingTeamLeader) {
      hasAccessToSubmitPolicyholderGroup = true;
    }
    return hasAccessToSubmitPolicyholderGroup;
  }

}
